$(document).ready(function() {
	if(!document.querySelector('.select-product-model')) return false;
	
	var modelSearch = {
		form: document.querySelector('.select-product-model form.search-common'),
		model: {
			input: null,
			$searchList: null
		},
		country: null,
		init: function(){
			modelSearch.model = {
				input: modelSearch.form.querySelector("#search"),
				$searchList: this.form.querySelector(".search-layer .list")
			}
			modelSearch.country = this.form.querySelector("#txtBoxCountry");
			
			if($(modelSearch.country).find('option[selected]').index() != 0){
				$(modelSearch.country).find('option').eq(0).remove();
				$(modelSearch.country).prop("disabled", false).trigger('chosen:updated');
			}
			chosenScrollInit();
			modelSearch.addEvent();
		},
		makeOptionList: function(target, data){
			var optionHtml = "";
			for (var key in data) {
				if (data.hasOwnProperty(key)) {
					optionHtml += "<option value='"+ key +"' data-url='"+ data[key].url +"'>"+ data[key].country +"</option>"
				}
			}
			$(target).find("option:not([disabled])").remove();
			$(target).append(optionHtml);
		},
		getCountryResult: function(target){
			$('body').trigger('ajaxLoadStart');

			var modelNumber = $(target).attr('href'),
				modelName = $(target).find('.model-name').text(),
				url = $(modelSearch.form).attr("data-url"),
				param = $(modelSearch.form).data('param') + "=" + modelName;

			modelSearch.model.input.value = modelName;
			modelSearch.form.keyword.value = modelNumber; // hidden input (Surfix)
			modelSearch.form.keywordNoSfx.value = modelName; // hidden input (not Surfix)

			$(modelSearch.form).find('.search-layer').removeClass('active');

			ajax.call(url, param, 'json', function(data){ 
				$('body').trigger('ajaxLoadEnd');
				modelSearch.makeOptionList(modelSearch.country, data);
				$(modelSearch.country).prop('disabled', false).trigger('chosen:updated');
			});
		},
		modelInputValid: function(state){
			var status;
			
			if(state){
				status = state;
			}else if(!modelSearch.model.input.value){
				status = "required";
			}else if(modelSearch.model.input.value != modelSearch.form.keywordNoSfx.value){
				status = "invalid";
			}else {
				status = "pass";
			}

			var $fieldBlock = $(modelSearch.model.input).parents(".field-block");

			switch (status) {
				case "required":
				case "invalid":
					!$fieldBlock.hasClass("error") && $fieldBlock.addClass("error");
					$fieldBlock.find(".error-msg ."+status).show().siblings().hide();
					$(modelSearch.form).find('.search-layer').removeClass('active');
					return false;
				case "pass":
					$fieldBlock.hasClass("error") && $fieldBlock.removeClass("error");
					$fieldBlock.find(".error-msg span").hide();
					return true;
				// default:
				// 	break;
			}
		},
		addEvent: function(){
			$(modelSearch.model.input).on({
				/*
				focus: function(){
					if(!modelSearch.country.getAttribute("disabled")){
						modelSearch.form.keyword.value = "";
						modelSearch.form.keywordNoSfx.value = "";
						$(modelSearch.country).parents(".field-block").removeClass("error").find(".error-msg span").hide();
					}
				},
				*/
				blur: function(){
					if($(this).val().trim() == ''){
						$(modelSearch.country).attr("disabled", "disabled").trigger('chosen:updated');
					}
				},
				keydown: function(){
					modelSearch.modelInputValid("pass");
				}
			});

			$(modelSearch.model.$searchList).on("click", "a", function(e){
				e.preventDefault();
				modelSearch.getCountryResult(this);
				
			});

			$(modelSearch.country).on('change', function(){
				var CountryUrl = $(this).find('option:selected').attr('data-url'); 
				var linkButton = $(modelSearch.form).find("[type='submit']");

				if(CountryUrl == ''){
					linkButton.removeAttr('onclick title');
				}else{
					linkButton.attr({onclick : 'location.href=" ' + CountryUrl + '"', title : 'Opens in a new window'});
				}
			});
			
			
			$(modelSearch.form).on("click", "[type='submit']", function(e){
				// LGEBR-995 start
				var localeCode =  window.location.href.split("/")[3];//DEV,STG,PRD 공통
				e.preventDefault();
				if(modelSearch.modelInputValid() && $(modelSearch.form).checkValidation()){
					if(localeCode == 'br'){
						//LGEBR-1048 submit될 때 form안의 값을 브라질에 맞게 업어치기(if not, 검색값의 첫번쨰 국가값이 넘어가버림)
						modelSearch.form.countryName.value = 'Brazil';//브라질로 하드 코딩
						$('#txtBoxCountry option:selected').val('BR');//submit되는 순간 select 박스의 val도 강제로 코딩하기 
					}else{
						modelSearch.form.countryName.value = $(modelSearch.country).chosen().find("option:selected").text();
					}

					if(!$(this).attr('onclick')){
						modelSearch.form.submit();
					}
					
				}
				// LGEBR-995 end
			});

			// 20200601 START 구유정 || input submit icon button valid 추가
			$(modelSearch.model.input).next(".submit").on({
				click: function(){
					if(modelSearch.modelInputValid() && $(modelSearch.form).checkValidation()){
						modelSearch.form.countryName.value = $(modelSearch.country).chosen().find("option:selected").text();
						modelSearch.form.submit();
					}
				}
			})
			// 20200601 END 구유정 || input submit icon button valid 추가
		},
		countryValid: function(){
			
		}
	}

	var searchResult = {
		el: document.querySelector(".search-result-area"),
		breadcrumbs: null,
		init: function(){
			searchResult.breadcrumbs = searchResult.el.querySelectorAll(".country-breadcrumbs");

			searchResult.addEvent();
		},
		breadcrumbsActive: function(e){
			var $target = $(e.target);
			var $breadcrumbs = $target.closest(".country-breadcrumbs");
			var $targetList = $breadcrumbs.parent().find($breadcrumbs.attr("data-target-list"));

			$breadcrumbs.find("a").removeClass("active");
			$target.addClass("active");

			if($target.attr("data-target") == "All"){
				$targetList.find("li").removeClass("hide");
			}else{
				$targetList.find("li").addClass("hide");
				$targetList.find("[data-link="+ $target.attr("data-target") +"]").removeClass("hide");
			}
		},
		addEvent: function(){
			$(searchResult.breadcrumbs).on("click", "a", function(e){
				e.preventDefault();
				searchResult.breadcrumbsActive(e);
			});
		}
	}

	var softwareModal = {
		el: document.getElementById("modal_software"),
		queryStringParameters: window.location.search,
		$activeBtns: null,
		$downloadList: null,
		init: function(){
			if(!softwareModal.el) {return false};
			softwareModal.$activeBtns = $(searchResult.el).find(".btn[href='#modal_software']");
			softwareModal.$downloadList = $(searchResult.el).find(".software-download-list");

			softwareModal.addEvent();
		},
		getModalData: function(e){
			var $target = $(e.target);
			var url = $target.attr('data-url');
			var param = softwareModal.queryStringParameters.split("?")[1] + "&" + $target.attr('data-url').split("?")[1];
			var methodType = $target.data('ajaxMethod');

			ajax.noCacheCall(url, param, 'html', function(data){
				if(data){
					var $modalBody = $(softwareModal.el).find('.modal-body');
					$modalBody.mCustomScrollbar('destroy');
					$modalBody.html("").append(data);
					$modalBody.mCustomScrollbar({theme:'dark'});
					runChosen();
				}
			}, methodType);
		},
		getListData: function(e, selected){
			var $target = $(e.target);
			var selectParam = '&' + $(e.target).attr('name') + '=' + selected;
			var url = $target.attr('data-url');
			var param = softwareModal.queryStringParameters.split("?")[1] + "&" + $target.attr('data-url').split("?")[1] + selectParam;
			var methodType = $target.data('ajaxMethod');

			ajax.noCacheCall(url, param, 'html', function(data){
				if(data){
					var $modalBody = $(softwareModal.el).find('.modal-body');
					$modalBody.find('.software-download-list').html("").append(data);
					$modalBody.mCustomScrollbar('update');
				}
			}, methodType);
		},
		addEvent: function(){
			softwareModal.$activeBtns.on("click", function(e){
				e.preventDefault();
				softwareModal.getModalData(e);
			});

			$(softwareModal.el).on("change", "select#searchOs", function(e){
				e.preventDefault();
				selected = $(this).val();
				softwareModal.getListData(e,selected);
			});
		}
	}



	modelSearch.init();
	searchResult.init();
	softwareModal.init();
	

	
	
});